import { reactive } from 'vue';

export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmText?: string;
  danger?: boolean;
  /** When set, the dialog asks for a reason and resolves with it. */
  requireReason?: boolean | 'optional';
  reasonLabel?: string;
}

interface ConfirmState extends ConfirmOptions {
  open: boolean;
  reason: string;
  resolve?: (value: string | false) => void;
}

export const confirmState = reactive<ConfirmState>({ open: false, title: '', reason: '' });

/** Promise-based confirm dialog. Resolves to the entered reason ('' when none) or false when cancelled. */
export function confirmDialog(opts: ConfirmOptions): Promise<string | false> {
  return new Promise((resolve) => {
    Object.assign(confirmState, { confirmText: 'Confirm', danger: false, requireReason: false, reasonLabel: 'Reason', message: undefined }, opts, {
      open: true,
      reason: '',
      resolve,
    });
  });
}

export function useConfirm() {
  return confirmDialog;
}
